import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import reduxThunk from "redux-thunk";
import authSlice from "./AuthReducer/authSlice";
import brandSlice from "./BrandReducer/brandSlice";
import campaignSlice from "./CampaignReducer/campaignSlice";
import collabSlice from "./CollabReducer/collabSlice";
import creatorsSlice from "./creators/creatorsSlice";
import loaderSlice from "./LoaderReducer/loaderSlice";
import uiActions from "./UIReducer/UiReducerSlice";
import utilsSlice from "./utilReducer/UtilsSlice";
import PerformanceSlice from "./PerformanceReducer/performanceSlice";
import accountsSlice from "./AccountsReducer/accounts.reducer";
import companySlice from "./CompanyReducer/companyReducer";
import campaignManagementSLice from "./ManagementReducer/managementSlice";
import deliverablesSlice from "./DeliverableTableReducer";
import creatorProfileSlice from "./CreatorProfileReducer/creatorProfileSlice";
import creatorMixSlice from "./CreatorMixReducer/creatorMixSlice";
import countrySlice from "./CountryReducer/countryReducer";
import myListSlice from "./MyListsReducer/mylistSlice";
import OrganisationSlice from "./OrganizationReducer";
import walletHistorySlice from "./WalletHistoryReducer/WalletHistorySlice";
import manageUserSlice from "./ManageUsersReducer/mangeUserSlice";
import userSlice from "./SaasUserReducer/userSlice";
import viewOrganisationSlice from "./OrganizationReducer/ViewOrganisationReducer";
import commonListSlice from "./CommonReducer/commonReducer";
import viewUserSlice from "./SaasUserReducer/ViewUserReducer";
import SocialCommerceSlice from "./PerformanceReducer/SocialCommerceReducer/SocialCommerceSlice"
import brandOnboardSlice from "./OnboardBrandReducer";
import productsSlice from "./ProductsReducer";
import categorySlice from "./ProductsReducer/CategoriesReducer";
import risingStarSlice from "./RisingStarReducer/risingStarSlice";
import couponSlice from "./CouponReducer/couponSlice";
import certifiedUserSlice from "./AniCertifiedReducer/certifiedUserSlice";
import dashboardSlice from "./DashBoardReducer/dashboardSlice";
import salesCommissionSlice from "./DashBoardReducer/SalesCommissionReducer/salesCommissionSlice";
import earningSlice from "./DashBoardReducer/earningSlice";
import allCampaignSlice from "./DashBoardReducer/allCampaignSlice";
import campaignDetailSlice from "./DetailedViewReducer/campaignDetailSlice";
import salesDetailSlice from "./DetailedViewReducer/SalesDetailSlice";
import { encryptTransform } from 'redux-persist-transform-encrypt';
import campaignCardSlice from "./CampaignReducer/campaignCardReducer";
import ProductListSlice from "./PerformanceReducer/DashboardProductReducer/ProductListSlice"

const reducers = combineReducers({
  creators: creatorsSlice.reducer,
  utils: utilsSlice,
  auth: authSlice.reducer,
  brand: brandSlice.reducer,
  campaign: campaignSlice.reducer,
  loader: loaderSlice.reducer,
  collab: collabSlice.reducer,
  ui: uiActions.reducer,
  company: companySlice.reducer,
  performance: PerformanceSlice.reducer,
  accounts: accountsSlice.reducer,
  campaignManagement: campaignManagementSLice.reducer,
  deliverables: deliverablesSlice.reducer,
  creatorProfile: creatorProfileSlice.reducer,
  creatorMix: creatorMixSlice.reducer,
  country: countrySlice.reducer,
  myList: myListSlice.reducer,
  organisation: OrganisationSlice.reducer,
  viewOrganisation: viewOrganisationSlice.reducer,
  viewUser: viewUserSlice.reducer,
  walletHistory: walletHistorySlice.reducer,
  manageUsers: manageUserSlice.reducer,
  users: userSlice.reducer,
  commonList: commonListSlice.reducer,
  socialCommerce: SocialCommerceSlice.reducer,
  ProductList: ProductListSlice.reducer,
  brandOnboard: brandOnboardSlice.reducer,
  products: productsSlice.reducer,
  category: categorySlice.reducer,
  risingStar: risingStarSlice.reducer,
  coupons: couponSlice.reducer,
  certifiedUser: certifiedUserSlice.reducer,
  dashboard: dashboardSlice.reducer,
  salesCommission: salesCommissionSlice.reducer,
  earning: earningSlice.reducer,
  allCampaign: allCampaignSlice.reducer,
  campaignDetail: campaignDetailSlice.reducer,
  salesDetail: salesDetailSlice.reducer,
  campaignCard: campaignCardSlice.reducer,

});

const persistedReducer = persistReducer(
  {
    key: "root",
    storage,
    blacklist: ["creators", "loader", "collab", "creatorProfile", "certifiedUser", "salesCommission", "earning"],
    transforms: [
      encryptTransform({
        secretKey: process.env.REACT_APP_SECRET_KEY,
        onError: function (error) {
          console.error(error);
        },
      }),
    ]
  }, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [reduxThunk],
});

export const persistor = persistStore(store);
